/**
 * helpers.js
 */

import React from 'react';
import { Typography } from '@mui/material';
import { isBefore, intervalToDuration, differenceInWeeks, parseISO } from 'date-fns';
import { Types } from 'utils/constants';
import { useTranslation } from 'react-i18next';


export const getPatrolIconName = (patrolType) => {
  switch (patrolType) {
    case Types.Patrol.AGILITY:
      return 'patrol-agility';

    case Types.Patrol.APPREHENSION:
      return 'patrol-apprehension';

    case Types.Patrol.BUILDING_SEARCH:
      return 'patrol-building-search';

    case Types.Patrol.EVIDENCE_SEARCH:
      return 'patrol-evidence-search';

    case Types.Patrol.HUMAN_SEARCH:
      return 'patrol-human-search';

    case Types.Patrol.OBEDIENCE:
      return 'patrol-obedience';

    case Types.Patrol.TRACKING:
      return 'patrol-tracking';

    case Types.Patrol.OTHER:
    default:
      return 'patrol-other';
  }
};


export const PatrolTypeTitle = (props) => {
  const { patrolType, patrolTypes } = props;
  const { t } = useTranslation('general');

  return (
    <div style={{ display: 'flex' }}>
      <Typography variant='subtitle2'>  
        {Types.Patrol.getName(t, patrolType).toUpperCase()} 
        {patrolTypes.length === 1 && patrolType !== Types.Patrol.OTHER
          ? ' Training'
          : ''}
      </Typography>
      {patrolTypes.length > 1 &&
      <Typography variant='subtitle2'>
        &nbsp;(Scenario)
      </Typography>}
      <br />
    </div>
  );
};


export const getSizeTypeAnalyticsLabel = (count) => {
  if (count <= 4) { 
    return `${count}`;
  } else if (count <= 8) { 
    return '5-8';
  } else if (count <= 14) {
    return '9-14';
  } else if (count <= 24) {
  return '15-24';
  } else {
    return '25+';
  }
};


export const getDurationTypeAnalyticsLabel = (duration) => {
  //0m-20m, 20m-60m, 1-2h, 2h-4h, 4h-8h, 8h+
  if (duration > 8) {
    return '8h+';
  } else if (duration > 4) {
    return '4h-8h';
  } else if (duration > 2) {
    return '2h-4h';
  } else if (duration > 1) {
    return '1h-2h';
  } else if (duration > (.25)) {
    return '15m-60m';
  } else {
    return '0m-15m';
  }
};


export const getRelTimeTypeAnalyticsLabel = (event) => {
  const createdTime = parseISO(event.dateCreated);
  const startTime = parseISO(event.date);
  const endTime = parseISO(event.endDate);

  if (isBefore(createdTime, startTime)) {
    // event created before it starts
    const delta = intervalToDuration({
      start: createdTime,
      end: startTime,
    });
    if (delta.days >= 7) {
      return '[0]beforestart_1w+';
    } else if (delta.days >= 1) {
      return '[1]beforestart_7dto1d';
    } else if (delta.hours >= 1) {
      return '[2]beforestart_24hto1h';
    } else if (delta.minutes >= 10) {
      return '[3]beforestart_60mto10m';
    } else {
      return '[4]beforestart_10mto0m';
    }
  } else if (isBefore(createdTime, endTime)) {
    // event created after it starts but before it ends
    const delta = intervalToDuration({
      start: startTime,
      end: createdTime,
    });
    if (delta.minutes >= 10) {
      return '[6]during_10mtoend';
    } else {
      return '[5]during_0mto10m';
    }
  } else {
    // event created after it ends
    const delta = intervalToDuration({
      start: endTime,
      end: createdTime,
    });
    if (differenceInWeeks(createdTime, endTime) >= 12) { // can't use a date-fns duration for weeks > 1m
      return '[d]afterend_12w+';
    } else if (delta.days >= (7*4)) {
      return '[c]afterend_4wto12w';
    } else if (delta.days >= 7) {
      return '[b]afterend_1wto4w';
    } else if (delta.days >= 1) {
      return '[a]afterend_1dto7d';
    } else if (delta.hours >= 4) {
      return '[9]afterend_4hto24h';
    } else if (delta.hours >= 1) {
      return '[8]afterend_1hto4h';
    } else {
      return '[7]afterend_0mto60m';
    }
  }
};